import { ARTIFACT_TYPES } from '../artifacts/artifactTypes';

const SOURCE_ONLY_ROUTE_PHRASES = [
  'not a specific timeline event',
  'not a specific event',
  'not a dated event',
  'static preference',
  'static preferences',
  'static food preference',
  'static food preferences',
  'static care information',
  'goals and strategies',
  'care plan section',
  'dedicated care plan',
  'reference document',
  'different record type',
  'feeding plan',
  'behavior support plan',
  'behavior support plan document',
  'safety plan',
  'safety plan document',
  'care plan document',
  'uploaded document',
  'source only',
  'saved as knowledge',
  'saved as care knowledge',
  'saved as a knowledge',
  'saved as a source',
  'saved as a document',
  'should be saved as knowledge',
  'should be saved as care knowledge',
  'should be saved as a source',
  'should be saved as a document',
  'do not save to timeline',
  'display as reference document',
];

const STATIC_CARE_PLAN_MARKERS = [
  'preferred foods',
  'foods working on',
  'likely triggers',
  'warning signs',
  'recommended responses',
  'safety plan',
  'risk',
  'triggers',
  'emergency contacts',
  'annual goal',
  'objectives',
  'review date',
  'accommodations',
  'monitor',
  'contact provider if',
  'purpose',
  'strategies',
];

const normalizeToken = (value = '') => (
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_')
);

const collectSuggestedRecordText = (suggestedRecord = {}) => [
  suggestedRecord.artifactType,
  suggestedRecord.candidateType,
  suggestedRecord.type,
  suggestedRecord.category,
  suggestedRecord.title,
  suggestedRecord.text,
  suggestedRecord.summary,
  suggestedRecord.sourceText,
  suggestedRecord.reviewReason,
  suggestedRecord.reviewNote,
  suggestedRecord.metadata?.reviewReason,
  suggestedRecord.metadata?.reviewNote,
  suggestedRecord.metadata?.captureFirst?.reviewLabel,
  suggestedRecord.record?.artifactType,
  suggestedRecord.record?.candidateType,
  suggestedRecord.record?.type,
  suggestedRecord.record?.category,
  suggestedRecord.record?.title,
  suggestedRecord.record?.text,
  suggestedRecord.record?.summary,
  suggestedRecord.record?.sourceText,
  suggestedRecord.record?.details,
  suggestedRecord.record?.notes,
  ...(Array.isArray(suggestedRecord.reviewReasons) ? suggestedRecord.reviewReasons : []),
  ...(Array.isArray(suggestedRecord.metadata?.reviewReasons) ? suggestedRecord.metadata.reviewReasons : []),
  ...(Array.isArray(suggestedRecord.metadata?.captureFirst?.reviewReasons) ? suggestedRecord.metadata.captureFirst.reviewReasons : []),
].filter(Boolean).join(' ').toLowerCase();

const hasStaticCarePlanShape = (searchableText = '') => {
  const markerCount = STATIC_CARE_PLAN_MARKERS.reduce(
    (count, marker) => count + (searchableText.includes(marker) ? 1 : 0),
    0
  );
  return markerCount >= 3;
};

export const shouldSkipTimelineSave = (suggestedRecord = {}) => {
  const artifactType = normalizeToken(
    suggestedRecord.artifactType || suggestedRecord.record?.artifactType
  );
  if (artifactType === ARTIFACT_TYPES.DOCUMENT_REFERENCE || artifactType === ARTIFACT_TYPES.SOURCE_ONLY) {
    return true;
  }

  const searchableText = collectSuggestedRecordText(suggestedRecord);
  if (hasStaticCarePlanShape(searchableText)) {
    return true;
  }

  const needsReview = Boolean(
    suggestedRecord.needsReview
    || suggestedRecord.reviewState === 'needs_review'
    || suggestedRecord.reviewReasons?.length
  );
  if (!needsReview) {
    return false;
  }

  return SOURCE_ONLY_ROUTE_PHRASES.some((phrase) => searchableText.includes(phrase));
};

export const isSourceOnlySuggestedRecord = shouldSkipTimelineSave;
